import * as React from 'react';
import {FunctionComponent, useMemo} from 'react';
import {GeoTrack} from '../../../../Models/GeoTrack';
// @ts-ignore
import GoogleMapReact from 'google-map-react';
import {GeoPoint} from '../../../../Models/GeoPoint';
import {MapSegment} from './GeoTrackMapColored';
import {centerPointOfGeoTrack} from '../../../../Geo/centerPointOfGeoTrack';

interface OwnProps {
    height: number;
    geoTrack: GeoTrack;
    selectedGeoPoint?: GeoPoint;
}

export const GeoTrackMap: FunctionComponent<OwnProps> = ({height, geoTrack}) => {
    const defaultProps = {
        center: centerPointOfGeoTrack(geoTrack),
        zoom: 13,
    };

    function handleApiLoaded(map: any, maps: any, path: GeoPoint[]) {
        if (path.length === 0) {
            return;
        }
        // Draw path.
        new maps.Polyline({
            path: path,
            geodesic: true,
            strokeColor: '#000000',
            strokeOpacity: 1,
            strokeWeight: 4,
        }).setMap(map);

        // Change map bounds based on geoTrack.
        const bounds = new maps.LatLngBounds();
        geoTrack.forEach((point) => {
            bounds.extend(new maps.LatLng(point.lat, point.lng));
        });
        map.fitBounds(bounds);
    }

    const mapOptions = {
        disableDefaultUI: true,
        styles: [
            {
                featureType: 'water',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#a0d6d1',
                    },
                    {
                        lightness: 17,
                    },
                ],
            },
            {
                featureType: 'landscape',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#ffffff',
                    },
                    {
                        lightness: 20,
                    },
                ],
            },
            {
                featureType: 'road.highway',
                elementType: 'geometry.fill',
                stylers: [
                    {
                        color: '#dedede',
                    },
                    {
                        lightness: 17,
                    },
                ],
            },
            {
                featureType: 'road.highway',
                elementType: 'geometry.stroke',
                stylers: [
                    {
                        color: '#dedede',
                    },
                    {
                        lightness: 29,
                    },
                    {
                        weight: 0.2,
                    },
                ],
            },
            {
                featureType: 'road.arterial',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#dedede',
                    },
                    {
                        lightness: 18,
                    },
                ],
            },
            {
                featureType: 'road.local',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#ffffff',
                    },
                    {
                        lightness: 16,
                    },
                ],
            },
            {
                featureType: 'poi',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#f1f1f1',
                    },
                    {
                        lightness: 21,
                    },
                ],
            },
            {
                elementType: 'labels.text.stroke',
                stylers: [
                    {
                        visibility: 'on',
                    },
                    {
                        color: '#ffffff',
                    },
                    {
                        lightness: 16,
                    },
                ],
            },
            {
                elementType: 'labels.text.fill',
                stylers: [
                    {
                        saturation: 36,
                    },
                    {
                        color: '#333333',
                    },
                    {
                        lightness: 40,
                    },
                ],
            },
            {
                elementType: 'labels.icon',
                stylers: [
                    {
                        visibility: 'off',
                    },
                ],
            },
            {
                featureType: 'transit',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#f2f2f2',
                    },
                    {
                        lightness: 19,
                    },
                ],
            },
            {
                featureType: 'administrative',
                elementType: 'geometry.fill',
                stylers: [
                    {
                        color: '#fefefe',
                    },
                    {
                        lightness: 20,
                    },
                ],
            },
            {
                featureType: 'administrative',
                elementType: 'geometry.stroke',
                stylers: [
                    {
                        color: '#fefefe',
                    },
                    {
                        lightness: 17,
                    },
                    {
                        weight: 1.2,
                    },
                ],
            },
        ],
    };
    return (
        <div style={{height: height, width: '100%'}}>
            <GoogleMapReact
                bootstrapURLKeys={{key: 'AIzaSyARpp-uOe0QHWfqqKt0Xvv4Q9DaNCXarU0'}}
                defaultCenter={defaultProps.center}
                defaultZoom={defaultProps.zoom}
                options={mapOptions}
                yesIWantToUseGoogleMapApiInternals
                onGoogleApiLoaded={({map, maps}: any) => handleApiLoaded(map, maps, geoTrack)}
            />
        </div>
    );
};
